import browserStorage from 'store';
import {
  ACCESS_TOKEN_KEY,
  clearGenerationRecord,
  EXPIRES_AT_KEY,
  GENERATION_ID_KEY,
  GENERATION_RECORD_KEY,
  ISSUED_AT_KEY,
  PROFILE_KEY,
  SCOPE_KEY,
  SessionStorageLike,
} from './sessionGenerationStore';

export const AUTH0_SPA_CACHE_KEY_PREFIX = '@@auth0spajs@@';

export const APP_OWNED_AUTH_STORAGE_KEYS = [
  ACCESS_TOKEN_KEY,
  EXPIRES_AT_KEY,
  SCOPE_KEY,
  PROFILE_KEY,
  ISSUED_AT_KEY,
  GENERATION_ID_KEY,
  GENERATION_RECORD_KEY,
] as const;

export const LOCAL_WORK_BACKUP_FAILED_REASON = 'local_work_backup.failed';
export const PKCE_CALLBACK_FAILED_REASON = 'pkce_callback_failed';
export const STORAGE_QUOTA_REASON = 'storage_quota';

export const isStorageQuotaError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const maybeError = error as { name?: unknown; code?: unknown };
  if (maybeError.name === 'QuotaExceededError' || maybeError.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
    return true;
  }

  return maybeError.code === 22 || maybeError.code === 1014;
};

const isBrowserLocalStorageKey = (key: string | null): key is string => Boolean(key);

/**
 * Bounded quota recovery: remove leftover Auth0 SPA cache keys and app-owned
 * auth/generation keys only. Never clears annotation drafts or other origin data.
 */
export const pruneAuth0AndGenerationStorage = (storage: SessionStorageLike = browserStorage): void => {
  if (typeof localStorage !== 'undefined') {
    const auth0Keys: string[] = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (isBrowserLocalStorageKey(key) && key.startsWith(AUTH0_SPA_CACHE_KEY_PREFIX)) {
        auth0Keys.push(key);
      }
    }
    auth0Keys.forEach((key) => {
      localStorage.removeItem(key);
    });
  }

  APP_OWNED_AUTH_STORAGE_KEYS.forEach((key) => {
    try {
      storage.remove(key);
    } catch (error) {
      console.error('Unable to prune app-owned auth storage key', error);
    }
  });
  clearGenerationRecord(storage);
};
